import { FILE_TYPES, MIME_TYPES } from 'www/constants'
import type {
  AlertDialogData,
} from 'src/components/pages/appointment/uslugi/new/components/ServiceAppointmentForm/components/AttachedFiles/types'
import { ComputedRef } from 'vue'

export default function useValidationRules({
  openFilePicker,
  validationOptions,
  attachedFileByteSizes,
}: {
  openFilePicker: () => void,
  validationOptions: {
    allowedFileMimeTypes: Array<typeof MIME_TYPES[keyof typeof MIME_TYPES]>
    allowedFileTypes: Array<typeof FILE_TYPES[keyof typeof FILE_TYPES]>
    maxSizeMb: number
    maxOverallSizeMb: number
    minResolution: {
      width: number
      height: number
    }
    maxImagePixels: number
  }
  attachedFileByteSizes: ComputedRef<number>
}) {
  const {
    allowedFileMimeTypes,
    allowedFileTypes,
    maxSizeMb,
    maxOverallSizeMb,
    minResolution,
    maxImagePixels,
  } = validationOptions

  const fileValidationRules: Array<{
    validate: (_file: File) => boolean
    error: AlertDialogData,
  }> = [
    {
      // @ts-ignore
      validate: (file: File) => allowedFileMimeTypes.includes(file.type),
      error: {
        title: 'Неподходящий формат',
        text: `Подойдёт ${allowedFileTypes.join(', ').toUpperCase()}`,
        confirm: {
          text: 'Понятно',
          callback: openFilePicker,
        },
      },
    },
    {
      validate: (file: File) => file.size <= maxSizeMb * 1024 * 1024,
      error: {
        title: 'Слишком большое фото',
        text: `Загрузите фото до ${maxSizeMb} МБ`,
        confirm: {
          text: 'Понятно',
          callback: openFilePicker,
        },
      },
    },
    {
      validate: (file: File) => ((file.size + attachedFileByteSizes.value) <= maxOverallSizeMb * 1024 * 1024),
      error: {
        title: 'Слишком большой размер файлов',
        text: `Общий размер не должен превышать ${maxOverallSizeMb} МБ.`,
        confirm: {
          text: 'Понятно',
          callback: openFilePicker,
        },
      },
    },
  ]

  const imageValidationRules = [
    {
      validate: ({ width, height }: HTMLImageElement) => (
        width >= minResolution.width && height >= minResolution.height
      ),
      error: {
        title: 'Слишком маленькое фото',
        text: `Загрузите фото от ${minResolution.width}x${minResolution.height} пикселей.`,
        confirm: {
          text: 'Понятно',
          callback: openFilePicker,
        },
      },
    },
    {
      validate: ({ width, height }: HTMLImageElement) => width * height <= maxImagePixels,
      error: {
        title: 'Слишком маленькое фото',
        text: `Загрузите фото от ${minResolution.width}x${minResolution.height} пикселей.`,
        confirm: {
          text: 'Понятно',
          callback: openFilePicker,
        },
      },
    },
  ]

  const pickFileError = {
    title: 'Не получилось загрузить фото',
    text: 'Попробуйте ещё раз.',
    confirm: {
      text: 'Понятно',
      callback: openFilePicker,
    },
  }

  return {
    fileValidationRules,
    imageValidationRules,
    pickFileError,
  }
}
